<span class="example-spacer"></span>
<div class="nav-links" fxShow="true">
  <a class="middle" (click)="scroll('home-section')">Home</a>
  <a class="middle" (click)="scroll('case-section')">Case Studies</a>
  <a class="middle" (click)="scroll('case-section')">Funding</a>

  <a class="middle" (click)="scroll('about-section')">About</a>
  <a class="middle" (click) ="scroll('news-section')"> News</a>
</div>
